// extracted by mini-css-extract-plugin
export default {"app-vector-footer":"_5D3LqezB"};